export default "__VITE_ASSET__D5u0JPwe__"